import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapPin } from 'lucide-react';
import { PAGE_CONTEXT_LABELS } from './qoreAIConfig';

const ContextChip = ({ context }) => {
  const { t } = useTranslation();
  if (!context?.pageType) return null;

  const labelKey = PAGE_CONTEXT_LABELS[context.pageType] || PAGE_CONTEXT_LABELS.general;

  return (
    <div className="qai-context-chip" title={context.page}>
      <MapPin size={12} aria-hidden />
      <span>{t(labelKey)}</span>
      {context.activeTab && (
        <span className="qai-context-chip__tab">· {context.activeTab}</span>
      )}
    </div>
  );
};

export default ContextChip;